import {DateRangeType} from 'common/types/reports/bookmark';

import {DateRange} from './date-range';

export class ImpactDateRange extends DateRange {
  public getDateRangeTypeOptions() {
    return [DateRangeType.Between, DateRangeType.Since];
  }
}
